import React from "react";

const TextareaComponent = () => {
	return (
		<div className={`ui form`} style={{ display: "flex" }}>
			<textarea
				disabled={true}
				rows={3}
			/>
		</div>
	);
};

TextareaComponent.information = {
	type: "textarea",
	name: "Textarea"
};

export default TextareaComponent;
